import { Input } from "antd";
import styled from "styled-components";

const { Search } = Input;

const StyledSearchInput = styled(Search)`
  .ant-btn {
    background-color: #f97319;
    border-color: #f97319;
    color: #fff;
    &:hover,
    &:focus,
    &:active {
      background-color: #f97319 !important;
      border-color: #f97319;
      color: #fff;
    }
  }
  .ant-input {
    &:hover,
    &:focus {
      border-color: #f97319;
    }
  }
`;

export default StyledSearchInput;
